import { breakpoints } from "@mytutor/shared-react-web-components/lib/theme";
import { css } from "@emotion/react";

export const mediaQueries = css`
  .forDesktopBlock {
    display: none;
    @media (min-width: ${breakpoints.desktop}px) {
      display: block;
    }
  }

  .forDesktopFlex {
    display: none;
    @media (min-width: ${breakpoints.desktop}px) {
      display: flex;
    }
  }

  .notForDesktopFlex {
    display: flex;
    @media (min-width: ${breakpoints.desktop}px) {
      display: none;
    }
  }
`;
